import _objectWithoutProperties from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import { Button, Icon } from '@jutro/components';
import styles from "./ContextSwitcher.module.css";
export const ContextSwitcherButton = _ref => {
  let children = _ref.children,
    others = _objectWithoutProperties(_ref, ["children"]);
  return React.createElement(Button, _extends({
    className: styles.contextSwitcherButton,
    renderContent: () => React.createElement(React.Fragment, null, children, React.createElement(Icon, {
      icon: "mi-expand_more"
    }))
  }, others));
};
ContextSwitcherButton.__docgenInfo = {
  componentName: "ContextSwitcherButton",
  packageName: "@jutro/router",
  description: "",
  displayName: "ContextSwitcherButton",
  methods: [],
  actualName: "ContextSwitcherButton"
};